import { render } from "./PrizeView.vue?vue&type=template&id=09832c66&ts=true"
import script from "./PrizeView.vue?vue&type=script&lang=ts"
export * from "./PrizeView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/Admin/Prizes/PrizeView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "09832c66"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('09832c66', __exports__)) {
    api.reload('09832c66', __exports__)
  }
  
  module.hot.accept("./PrizeView.vue?vue&type=template&id=09832c66&ts=true", () => {
    api.rerender('09832c66', render)
  })

}


export default __exports__